import React, { useEffect, useRef, useState } from 'react';
import { FaBell, FaUserCircle, FaChevronDown, FaSignOutAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { FaPlus } from "react-icons/fa6";
import { FiEdit3 } from 'react-icons/fi';
import { MdOutlineArrowOutward } from 'react-icons/md';
import { IoPerson } from "react-icons/io5";
import { MdOutlineMailOutline } from "react-icons/md";
import { FaDownload } from "react-icons/fa6";


const SuperAdminChancler = () => {
  // Dropdown state & refs
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const notificationRef = useRef(null);
  const profileRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (notificationRef.current && !notificationRef.current.contains(e.target)) {
        setShowNotifications(false);
      }
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Hard-coded pagination settings
  const itemsPerPage = 3;
  const totalPages = 2;
  const [currentPage, setCurrentPage] = useState(1);

  // Branch data with status management
  const [branches, setBranches] = useState([
    { id: 1, name: 'David', email: 'david@gmail.com', mobile: <div className='d-flex'><Link className='text-primary '>Assign</Link><Link className='text-danger mx-2'>Remove</Link> </div>, add: '06/18/2005', last: '06/18/2005', status: 'Active' },
    { id: 2, name: 'Sarah', email: 'sarah@office.com', mobile: <div className='d-flex'><Link className='text-primary '>Assign</Link><Link className='text-danger mx-2'>Remove</Link> </div>, add: '05/10/2006', last: '05/11/2006', status: 'Blocked' },
    { id: 3, name: 'Mark', email: 'mark@branch.com', mobile: <div className='d-flex'><Link className='text-primary '>Assign</Link><Link className='text-danger mx-2'>Remove</Link> </div>, add: '04/01/2007', last: '04/02/2007', status: 'De-active' },
    { id: 4, name: 'Alice', email: 'alice@branch.com', mobile: <div className='d-flex'><Link className='text-primary '>Assign</Link><Link className='text-danger mx-2'>Remove</Link> </div>, add: '03/15/2008', last: '03/16/2008', status: 'Active' },
    { id: 5, name: 'Bob', email: 'bob@branch.com', mobile: <div className='d-flex'><Link className='text-primary '>Assign</Link><Link className='text-danger mx-2'>Remove</Link> </div>, add: '02/20/2009', last: '02/21/2009', status: 'Pending' },
    { id: 6, name: 'Emma', email: 'emma@branch.com', mobile: <div className='d-flex'><Link className='text-primary '>Assign</Link><Link className='text-danger mx-2'>Remove</Link> </div>, add: '01/05/2010', last: '01/06/2010', status: 'Active' },
  ]);

  // Toggle branch status
  const toggleBranchStatus = (id) => {
    setBranches(prev => prev.map(branch => 
      branch.id === id 
        ? { 
            ...branch, 
            status: branch.status === 'Active' ? 'De-active' : 'Active' 
          } 
        : branch
    ));
  };

  // Status badge helper
  const getStatusClass = (status) => {
    switch (status.toLowerCase()) {
      case 'active': return 'status-badge active';
      case 'blocked': return 'status-badge blocked';
      case 'de-active': return 'status-badge de-active';
      case 'pending': return 'status-badge pending';
      default: return 'status-badge';
    }
  };

  return (
    <div className="container dashboard">
      {/* Top bar */}
       <div className="container ">
           <div className="row">
             <div className="d-flex flex-row align-items-center justify-content-end">
               {/* Notification Dropdown */}
               <div className="position-relative me-3" ref={notificationRef}>
                 <button 
                   className="btn btn-link text-decoration-none p-2 bg-white rounded-3 shadow-sm d-flex align-items-center"
                   onClick={() => setShowNotifications(!showNotifications)}
                 >
                   <FaBell className="fs-4 text-muted" />
                   <span className="position-absolute text-danger top-0 start-100 translate-middle badge rounded-pill bg-danger">
                       .
                     </span>
                 </button>
                 
                 {/* Notification Dropdown Menu */}
                 {showNotifications && (
                    <div className="dropdown-menu show notificationadmin shadow-lg p-0">
                    <div className="p-3 border-bottom">
                      <h6 className="fw-bold mb-0">Notifications</h6>
                    </div>
                    <div className="overflow-auto" style={{ maxHeight: '300px' }}>
                      <a href="#" className="dropdown-item d-flex py-3 border-bottom">
                        <div className='text-start'>
                          <p className="mb-0 fw-medium">New message received</p>
                          <small className="text-muted">You have 2 unread messages</small>
                          <div className="text-muted small mt-1">2 hours ago</div>
                        </div>
                      </a>
                      <a href="#" className="dropdown-item d-flex py-3 border-bottom">
                        <div className='text-start'>
                          <p className="mb-0 fw-medium">Meeting reminder</p>
                          <small className="text-muted">Team meeting at 3:00 PM</small>
                          <div className="text-muted small mt-1">5 hours ago</div>
                        </div>
                      </a>
                      <a href="#" className="dropdown-item d-flex py-3">
                        <div className='text-start'>
                          <p className="mb-0 fw-medium">System update</p>
                          <small className="text-muted">Maintenance scheduled for tomorrow</small>
                          <div className="text-muted small mt-1">Yesterday</div>
                        </div>
                      </a>
                      {/* Additional items to show scrollbar */}
                      <a href="#" className="dropdown-item d-flex py-3 border-top">
                        <div className='text-start'>
                          <p className="mb-0 fw-medium">New feature available</p>
                          <small className="text-muted">Check out the latest updates</small>
                          <div className="text-muted small mt-1">2 days ago</div>
                        </div>
                      </a>
                      <a href="#" className="dropdown-item d-flex py-3">
                        <div className='text-start'>
                          <p className="mb-0 fw-medium">Document approved</p>
                          <small className="text-muted">Your submission has been approved</small>
                          <div className="text-muted small mt-1">3 days ago</div>
                        </div>
                      </a>
                    </div>
                    <div className="text-center py-2 border-top">
                      <a href="#" className="text-primary text-decoration-none small">View all notifications</a>
                    </div>
                  </div>
                 )}
               </div>
               
               {/* User Profile Dropdown */}
               <div className="position-relative" ref={profileRef}>
                 <button 
                   className="btn btn-link text-decoration-none p-2 bg-white rounded-3 shadow-sm d-flex align-items-center"
                   onClick={() => setShowProfileMenu(!showProfileMenu)}
                 >
                   <div className="d-flex flex-column align-items-end me-2">
                     <span className="fw-bold text-dark">derek aivarado</span>
                     <span className="small text-muted">Admin</span>
                   </div>
                   <div className="position-relative">
                     <div className="bg-light border rounded-circle p-1">
                       <FaUserCircle className="fs-1 text-primary" />
                     </div>
                     <FaChevronDown className="text-muted small position-absolute bottom-0 end-0 bg-white rounded-circle p-1 border" style={{ fontSize: '0.6rem' }} />
                   </div>
                 </button>
                 
                 {/* Profile Dropdown Menu */}
                 {showProfileMenu && (
                   <div className="dropdown-menu show shadow-lg" style={{ width: '220px', right: 0, left: 'auto', display: 'block' }}>
                     <div className="text-center p-3 border-bottom">
                       <FaUserCircle className="fs-1 text-primary mb-2" />
                       <h6 className="mb-0 fw-bold">derek aivarado</h6>
                       <small className="text-muted">RY Admin</small>
                     </div>
                     <a href="#" className="dropdown-item d-flex align-items-center py-2">
                       <FaUserCircle className="me-3 text-muted" />
                       <span>My Profile</span>
                     </a>
                   
                     <div className="dropdown-divider my-1"></div>
                     <a href="#" className="dropdown-item d-flex align-items-center py-2 text-danger">
                       <FaSignOutAlt className="me-3" />
                       <span>Logout</span>
                     </a>
                   </div>
                 )}
               </div>
             </div>
             </div>
          </div>

      {/* Header & Breadcrumb */}
      <h2 className="fw-bold mb-1">Counsellor</h2>
      <div className="small mb-4">
        <Link to="/super-admin/dashboard" className="text-decoration-none text-dark">DASHBOARD</Link> / <span className="fw-bold">COUNSELLOR</span>
      </div>

      {/* Filters */}
      <div className="row align-items-center mb-4">
        <div className="col-md-3 col-6">
          <Link to="/super-admin/counsellor/add" className="btn btn-outline-primary buttonadd">
            <FaPlus /> ADD COUNSELLOR
          </Link>
        </div>
        <div className="col-md-2 col-6"><input type="text" placeholder="Keyword" className="form-control" /></div>
        <div className="col-md-2 col-6 ">
            
            <input type="email" placeholder="E-mail" className="form-control" />

      
        </div>
        <div className="col-md-2 col-6 d-flex">
          <select className="form-control" defaultValue="">
            <option value="" disabled>Status</option>
            <option>Active</option>
            <option>Inactive</option>
            <option>Pending</option>
          </select>
               <div className="tooltip-container">
      <button className="btn mx-2 btn-lg buttonfilter">
        <FaDownload />
      </button>
      <span className="tooltip-text">Download CSV</span>
    </div>
        </div>
        <div className="col-md-3 col-12"><input type="text" placeholder="Search" className="form-control" /></div>
      </div>

      {/* Table */}
      <div className="table-wrapper">
        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Counsellor Details</th>
              <th>Institute Info</th>
              <th>Add Date</th>
              <th>Last Login</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {branches
              .filter((_, index) => 
                (currentPage === 1 && index < itemsPerPage) || 
                (currentPage === 2 && index >= itemsPerPage)
              )
              .map(branch => (
                <tr key={branch.id}>
                  <td>{branch.id}</td>
                  <td>
                    <IoPerson size={20} color='#af52de' /> {branch.name}
                    &nbsp;
                    <MdOutlineMailOutline size={20} className='text-warning' /> {branch.email}
                  </td>
                  <td>{branch.mobile}</td>
                  <td>{branch.add}</td>
                  <td>{branch.last}</td>
                  <td>
                    <div className="d-flex align-items-center">
                      <div 
                        className={`toggle-switch ${branch.status === 'Active' ? 'active' : ''}`}
                        onClick={() => toggleBranchStatus(branch.id)}
                      >
                        <div className="slider"></div>
                        <span className="active-text">ON</span>
                        <span className="inactive-text">OFF</span>
                      </div>
                      <span className={`ms-2 ${getStatusClass(branch.status)}`}>
                        {branch.status}
                      </span>
                    </div>
                  </td>
                  <td className="d-flex gap-2">
                    <button className="btn btn-sm btn-light"><MdOutlineArrowOutward /></button>
                    <button className="btn btn-sm btn-light"><FiEdit3 /></button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="pagination mt-3">
          {[...Array(totalPages)].map((_, idx) => (
            <button
              key={idx}
              className={`page-button ${currentPage === idx + 1 ? 'active' : ''}`}
              onClick={() => setCurrentPage(idx + 1)}
            >
              {idx + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SuperAdminChancler;